import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MultiSelectComponent } from './multi-select.component';


@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
  ],
  declarations: [
    MultiSelectComponent
  ],
  exports: [
    MultiSelectComponent
  ]
})
export class MultiSelectModule { }
